// extracted by css-extract-rspack-plugin
export default {"SidesheetContent":"QqTsB","FlexScrollContainer":"aJtdu","OverflowAuto":"CPwLu"};